export default __webpack_public_path__ + "static/media/marketing-image2.1e5d8f8d.png";